import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import { NumberInput, required } from "react-admin";

interface FuelScoringAccordionProps {
  source: string;
  name: string;
}

export const FuelScoringAccordion: React.FC<FuelScoringAccordionProps> = ({ source, name }) => (
  <Accordion style={{ width: '100%' }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography>{name}</Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Box display="flex" alignItems="center" gap={2}>
        <NumberInput
          source={`${source}.factor`}
          label="Fator de pontuação"
          min={0}
          step={0.01}
          helperText="Pontos por litro. Ex: 1.5 = 1,5 pontos/litro"
          validate={required()}
          sx={{ width: 250 }}
        />
      </Box>
    </AccordionDetails>
  </Accordion>
);

export default FuelScoringAccordion;
